<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import {smsSendStatus,smsSendType} from "@utils/formatList"
  export default {
    name: "SendRecord",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        // 统计
        countList: [
          {name: "发送总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "时间", property: "create_at"},
            {label: "商家名称", property: "shopName"},
            {label: "短信类型", property: "type", format: smsSendType},
            {label: "手机号", property: "mobile"},
            {label: "短信内容", property: "content"},
            {label: "状态", property: "status", format:smsSendStatus},
            {label: "操作IP", property: "ip"},
          ],
        },
      }
    },
    methods: {
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        let res = await this.$Http.getSmsSendList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
